import { render, staticRenderFns } from "./insurance-layout.vue?vue&type=template&id=7acb52b0"
import script from "./insurance-layout.vue?vue&type=script&lang=js"
export * from "./insurance-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports